import {initializeApp} from 'firebase/app';
import { getFirestore } from 'firebase/firestore'


const firebaseConfig = {
  apiKey: "AIzaSyBIjko_2Z9Emrp1FPBtnRqH4UYO_TdoNx0",
  authDomain: "miafilmia-order.firebaseapp.com",
  databaseURL: "https://miafilmia-order-default-rtdb.firebaseio.com",
  projectId: "miafilmia-order",
  storageBucket: "miafilmia-order.appspot.com",
  messagingSenderId: "437129704039",
  appId: "1:437129704039:web:5df5489c5e00d3ac391ac2"
};

  const fireDB = initializeApp(firebaseConfig);
  const db = getFirestore(fireDB);
  export default db;